import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { IMAGES } from "../config";

export default function BundleMockup() {
  const ref = useRef(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const rotateX = useSpring(useTransform(my, [0, 1], [7, -7]), { stiffness: 140, damping: 18 });
  const rotateY = useSpring(useTransform(mx, [0, 1], [-9, 9]), { stiffness: 140, damping: 18 });

  const handleMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width);
    my.set((e.clientY - r.top) / r.height);
  };
  const reset = () => {
    mx.set(0.5);
    my.set(0.5);
  };

  return (
    <div
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      style={{ perspective: 1200 }}
      className="relative max-w-sm mx-auto lg:max-w-none pt-6 pb-12"
    >
      <motion.div style={{ rotateX, rotateY, transformStyle: "preserve-3d" }} className="relative">
        <motion.div
          animate={{ y: [0, -8, 0] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          className="relative"
        >
          <div className="relative z-10 w-full rotate-[-1.5deg] border border-cream/15 bg-black shadow-[0_40px_80px_-20px_rgba(0,0,0,0.9)] overflow-hidden">
            <img
              src={IMAGES.offer}
              alt="Dasha Love with the BLUEPRINT Identity Shift offer — course, bonus book and community"
              className="w-full h-auto block"
              loading="eager"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
            <span className="absolute bottom-3 left-3 bg-ink/70 backdrop-blur px-2.5 py-1 font-mono text-[8px] tracking-[0.25em] uppercase text-cream/90 border border-cream/15">
              Dasha Love × Blueprint™
            </span>
          </div>

          <div className="absolute -right-1 sm:-right-4 -bottom-8 z-30 w-20 sm:w-24 aspect-[9/17] rounded-md border border-cream/20 bg-coal shadow-2xl p-1.5 rotate-[3deg]">
            <div className="h-full rounded-sm bg-black border border-cream/10 p-2 flex flex-col gap-2">
              <div className="flex items-center justify-between">
                <span className="font-mono text-[7px] tracking-[0.2em] text-cream">SKOOL</span>
                <span className="w-1 h-1 rounded-full bg-lime" />
              </div>
              {[0, 1, 2].map((i) => (
                <div key={i} className="flex items-start gap-1.5">
                  <div className={`w-3 h-3 rounded-full shrink-0 ${i === 1 ? "bg-gold/70" : "bg-cream/20"}`} />
                  <div className="flex-1 space-y-1">
                    <div className="h-1 bg-cream/15 w-full" />
                    <div className="h-1 bg-cream/10 w-2/3" />
                  </div>
                </div>
              ))}
              <p className="mt-auto font-mono text-[6px] tracking-[0.15em] uppercase text-lime">
                Community access
              </p>
            </div>
          </div>

          <div className="absolute -bottom-6 right-10 z-40 bg-lime text-ink font-mono text-[9px] font-semibold tracking-[0.12em] uppercase px-3 py-1.5 -rotate-3 shadow-[0_10px_30px_rgba(204,255,0,0.25)]">
            $111 · Instant Access
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}
